import { useState } from 'react';
import Button from '../../../external/components/Button/Button';
import Text from '../../../external/components/Text/Text';
import { ProviderRpcError } from '../../../types/metamask.types';
import { useNakedStakingPool } from '../hooks/usePool';
import { useStakingActions } from '../hooks/useStakingAction';
import { StakingScreenEnum } from './_Screens';

interface Props {
  setScreen: React.Dispatch<React.SetStateAction<StakingScreenEnum>>;
  setWithdrawnAmount: React.Dispatch<React.SetStateAction<number>>;
}

export function WithdrawConfirm({ setScreen, setWithdrawnAmount }: Props) {
  const [withdrawLoading, setWithdrawLoading] = useState(false);

  const pool = useNakedStakingPool();
  const { unstakeData } = pool;

  const { withdraw } = useStakingActions({ pool });

  const handleWithdraw = async () => {
    try {
      setWithdrawLoading(true);
      await withdraw();
      setWithdrawnAmount(unstakeData.amount);
      setWithdrawLoading(false);
      setScreen(StakingScreenEnum.WITHDRAW_SUCCESS);
    } catch (_error) {
      setWithdrawLoading(false);
      const error = _error as ProviderRpcError;
      if (error.code === 4001) {
        // do nothing if RPC error
        return;
      } else {
        setScreen(StakingScreenEnum.ERROR);
      }
    }
  };

  return (
    <>
      <Button
        size='small'
        variant='secondary'
        dark={true}
        onClick={() => setScreen(StakingScreenEnum.HOME_SCREEN)}
        disabled={withdrawLoading}
      >
        ⬅
      </Button>
      <div className='flex direction-column align-center'>
        <Text color='lightgrey' style={{ margin: '0.5rem 0' }}>
          {' '}
          You are withdrawing
        </Text>
        <Text dark={true} size='xxl' style={{ margin: '0.5rem 0' }}>
          {unstakeData.amount} {pool.stakingTokenSymbol}
        </Text>
        <Text color='green' style={{ margin: '0.25rem 0 2rem' }}>
          {unstakeData.usdAmount} USD
        </Text>
        <Button
          dark={true}
          variant='primary'
          onClick={handleWithdraw}
          loading={withdrawLoading}
          disabled={withdrawLoading}
        >
          {withdrawLoading ? 'Processing...' : 'Confirm withdraw'}
        </Button>
      </div>
    </>
  );
}
